import React, { useEffect, useState } from "react";
import jwtDecode from "jwt-decode";
import { Link } from "react-router-dom";
import DataTable from "react-data-table-component";
import TableStyles from "react-data-table-component";

import user_Store from "../../store/user_store";
import student_Store from "../../store/student_store";
import attend_Store from "../../store/attend_store";
import {
  Button,
  ButtonGroup,
  DropdownButton,
  Dropdown,
  SplitButton,
} from "react-bootstrap";
import ExportCSV from "../../functions/ExportCSV";
import Selector_Component from "../../component/Selector_Component";
import supervisor_Store from "../../store/supervisor_store";
import admin_Store from "../../store/admin_store";
import CurrUser from "../../functions/UserAuth";
import Student_Manage_Modal from "../../component/Student_Manage_Modal";

function AttendsPage() {
  // Student Store
  const student = student_Store((state) => state.student);
  // Attend Store
  // const attend = attend_Store((state) => state.attend)
  // Supervisor Store
  const supervisor = supervisor_Store((state) => state.supervisor);
  // Admin Store
  const admin = admin_Store((state) => state.admin);

  const suffix = process.env.REACT_APP_SUFFIX_ROUTE;
  const attendsBaseOnSupervisor = attend_Store(
    (state) => state.attendsBaseOnSupervisor
  );
  const getAttendsBaseOnSupervisor = attend_Store(
    (state) => state.getAttendsBaseOnSupervisor
  );
  const [page, setPage] = useState(1);
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(10);

  const currentUser = CurrUser(student, supervisor, admin);

  const columns = [
    {
      name: "ID",
      selector: (row, index) => index + 1,
      sortable: true,
      width: "200px",
      id: 1,
    },
    {
      name: "Student email",
      selector: (row) => row.student.email ?? "",
      sortable: true,
      id: 2,
    },
    {
      name: "Student name",
      selector: (row) => row.student?.name ?? "",
      id: 3,
    },
    {
      name: "Date/Time",
      selector: (row) =>
        new Date(row?.created_at ?? "")?.toLocaleString()?.replace(",", "-") ??
        "",
      id: 4,
    },
    {
      name: "Status",
      selector: (row) => row?.statusRequest ?? "",
      id: 5,
    },
    {
      name: "Request",
      cell: (row) => {
        // state={{ from: "occupation" }}
        return (
          <Link
            to={{ pathname: `${suffix}/attends/student` }}
            state={{
              student: row?.student,
              tableJson: row?.attendtable?.tableJson ?? "",
              note: row?.note ?? "",
              status: row?.statusRequest ?? "",
            }}
            className="btn text-white bg-primary btn-md"
            type="button"
          >
            open
          </Link>
        );
      },
      // width: '60px',
      ignoreRowClick: true,
      allowOverflow: true,
    },
  ];
  let [mydata, setMydata] = useState([]);

  useEffect(() => {
    getAttendsBaseOnSupervisor();
  }, []);
  const handlePerRowsChange = (newPerPage) => {
    setPerPage(newPerPage);
  };

  const handlePageChange = (page) => {
    setPage(page);
  };
  const [resetPaginationToggle, setResetPaginationToggle] =
    React.useState(false);

  function onChange(e) {
    let word = e.target.value;
    const result = attendsBaseOnSupervisor.data.filter((item) => {
      return (
        (item.student.name &&
          item.student.name.toLowerCase().includes(word.toLowerCase())) ||
        item.student.email.includes(word) ||
        item?.id === word
      );
    });

    setMydata(result);

    if (word === "") {
      setMydata([]);
      setResetPaginationToggle(!resetPaginationToggle);
    }
  }

  function exportTable() {
    let arr = mydata.length > 0 ? mydata : filteredData;
    arr.forEach((obj, index) => (obj.id = index + 1));
    arr.forEach((obj) => delete obj.image);
    arr.forEach((obj) => delete obj.roles);
    arr.forEach((obj) => (obj.majors = obj?.majors?.[0]?.name ?? ""));
    arr.forEach((obj) => (obj.cohorts = obj?.cohorts?.[0]?.name ?? ""));
    arr.forEach((obj) => (obj.supervisors = obj?.supervisors?.[0]?.name ?? ""));
    ExportCSV(arr, "students");

    // ExportCSV(mydata.length > 0 ? mydata : attendsBaseOnSupervisor.data, 'students')
  }

  const uniqueStudents = {};
  let filteredData = [];

  filteredData = mydata?.filter((item) => {
    if (!uniqueStudents[item.student.id]) {
      uniqueStudents[item.student.id] = true;
      return true;
    }
    return false;
  });

  if (filteredData.length === 0) {
    filteredData = attendsBaseOnSupervisor?.data?.filter((item) => {
      if (!uniqueStudents[item.student.id]) {
        uniqueStudents[item.student.id] = true;
        return true;
      }
      return false;
    });
  }

  return (
    <>
      <div className="d-flex bd-highligh pb-2">
        <div className="pt-2 flex-grow-1 bd-highlight">
          <input
            type="text"
            onChange={(e) => onChange(e)}
            className="form-control w-50"
            placeholder="Search.."
            required
            aria-label=""
            aria-describedby="basic-addon1"
          />
        </div>

        <div className="p-2 bd-highlight">
          {/* <button onClick={function () { exportTable() }} className="btn   btn-md btn btn-outline-primary" type="button">CSV</button> */}
        </div>
      </div>

      <DataTable
        title="Attend Requests"
        columns={columns}
        data={filteredData ?? []}
        // data={mydata?.length > 0 ? mydata : attendsBaseOnSupervisor?.data}
        progressPending={false}
        // pagination
        paginationResetDefaultPage={resetPaginationToggle}
        paginationTotalRows={filteredData?.length ?? 0}
        // paginationTotalRows={ddata}
        onChangeRowsPerPage={handlePerRowsChange}
        onChangePage={handlePageChange}
        pointerOnHover
        highlightOnHover
      />
    </>
  );
}

export default AttendsPage;
